export default __webpack_public_path__ + "media/images/stop-reserved-16-e40fcf5a8c14c734883f1bb59d4260e5.png";